import defineImg from "../images/software-and-apps/Define.svg";
import empathizeImg from "../images/software-and-apps/Empathize.svg";
import ideateImg from "../images/software-and-apps/Ideate.svg";
import maintainImg from "../images/software-and-apps/Maintain.svg";
import prototypeImg from "../images/software-and-apps/Prototype.svg";
import testImg from "../images/software-and-apps/Test.svg";
//
import cloudArchitectureImg from "../images/software-and-apps/Cloud-Architecture.svg";
import cloudMaintainanceImg from "../images/software-and-apps/Cloud-Maintenance.svg";
import cloudMigrationImg from "../images/software-and-apps/Cloud-Migration.svg";
import cloudToolsImg from "../images/software-and-apps/Cloud-Tool-Development.svg";
import teamAugmentationImg from "../images/software-and-apps/Team-Augmentation.svg";

//
import microservicesImg from "../images/software-and-apps/Microservices.svg";
import reAttachingImg from "../images/software-and-apps/Re-architecting.svg";
import serverlessImg from "../images/software-and-apps/Serverless.svg";

//
import lavavelImg from "../images/software-and-apps/Laravel.svg";
import nodejsImg from "../images/software-and-apps/Node-.-js.svg";
import reactjsImg from "../images/software-and-apps/React.svg";
import sysfonyImg from "../images/software-and-apps/Symfony.svg";

//
import androidImg from "../images/software-and-apps/Android-iOS.svg";
import apiImg from "../images/software-and-apps/API-first.svg";
import compliantImg from "../images/software-and-apps/Compliant.svg";

//
import architectureUpdateImg from "../images/software-and-apps/Architecture-update.svg";
import developmentImg from "../images/software-and-apps/Development.svg";
import migrationImg from "../images/software-and-apps/Migration.svg";
import optimizationImg from "../images/software-and-apps/Optimization.svg";
import scalabilityImg from "../images/software-and-apps/Scalability-work.svg";

export const digitalProductDesignData = [
  {
    title: "Empathize",
    img: empathizeImg,
  },
  {
    title: "Define",
    img: defineImg,
  },
  {
    title: "Ideate",
    img: ideateImg,
  },
  {
    title: "Test",
    img: testImg,
  },
  {
    title: "Prototype",
    img: prototypeImg,
  },
  {
    title: "Maintain",
    img: maintainImg,
  },
];

export const cloudEngineeringData = [
  {
    title: "Cloud Architecture",
    img: cloudArchitectureImg,
  },
  {
    title: "Cloud Migration",
    img: cloudMigrationImg,
  },
  {
    title: "Team Augmentation",
    img: teamAugmentationImg,
  },
  {
    title: "Cloud Maintenance",
    img: cloudMaintainanceImg,
  },
  {
    title: "Cloud Tool Development",
    img: cloudToolsImg,
  },
];

export const resilientSoftwareData = [
  {
    title: "Microservices",
    img: microservicesImg,
  },
  {
    title: "Cloud Migration",
    img: cloudMigrationImg,
  },
  {
    title: "Serverless",
    img: serverlessImg,
  },
  {
    title: "Re-architecting",
    img: reAttachingImg,
  },
];

export const webDevelopmentData = [
  { title: "Node.js", img: nodejsImg },
  { title: "React", img: reactjsImg },
  { title: "Laravel", img: lavavelImg },
  { title: "Symfony", img: sysfonyImg },
];

export const mobileDevelopmentData = [
  {
    title: "API-first",
    img: apiImg,
  },
  {
    title: "Android/iOS",
    img: androidImg,
  },
  {
    title: "Compliant",
    img: compliantImg,
  },
];

export const consultancyData = [
  {
    title: "Architecture update",
    img: architectureUpdateImg,
  },
  {
    title: "Migration",
    img: migrationImg,
  },
  {
    title: "Development",
    img: developmentImg,
  },
  {
    title: "Optimization",
    img: optimizationImg,
  },
  {
    title: "Scalability work",
    img: scalabilityImg,
  },
];

export const softwareAndAppsMenus = [
  {
    link: "#digital-product-design",
    label: "Digital Product Design",
  },
  {
    link: "#agile-development-teams-on-demand",
    label: "Agile Development Teams On Demand",
  },
  {
    link: "#cloud-adoption-and-engineering",
    label: "Cloud Adoption & Engineering",
  },
  {
    link: "#resilient-software-architecture",
    label: "Resilient Software Architecture",
  },
  {
    link: "#web-development",
    label: "Web development",
  },
  {
    link: "#mobile-development",
    label: "Mobile development",
  },
  {
    link: "#quality-assurance-as-a-service",
    label: "Quality Assurance As a Service",
  },
  {
    link: "#technology-audit-and-consultancy",
    label: "Technology Audit & Consultancy",
  },
];
